import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaYoutube, FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "../../index.css";
// Use local video for presentation
import videoSrc from "../../assets/ele.mp4";
// Commented out image imports for now - will be used later
// import hero1 from "../../assets/hero-img-1.jpg";
// import hero2 from "../../assets/hero-img-2.jpg";
// import hero3 from "../../assets/hero-img-3.jpg";
// import hero4 from "../../assets/hero-img-4.jpg";
// import hero5 from "../../assets/hero-img-5.jpg";

// Commented out images array for now - will be used later
// const images = [hero1, hero2, hero3, hero4, hero5];

const HeroSection = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Commented out image state and effect for now - will be used later
  // const [currentImage, setCurrentImage] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImage((prevImage) => (prevImage + 1) % images.length);
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className="relative h-[80vh] overflow-hidden">
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Commented out image shuffling for now - will be used later */}
      {/* {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out ${
            index === currentImage ? "opacity-100 zoom-effect" : "opacity-0"
          }`}
          style={{
            backgroundImage: `url(${img})`,
            animationPlayState: index === currentImage ? "running" : "paused",
          }}
        />
      ))} */}

      {/* Content Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white p-4">
        <h1 className="text-6xl md:text-7xl lg:text-8xl tracking-wider font-bold mb-4 text-center">
          GET READY
        </h1>
        <p className="text-3xl md:text-4xl lg:text-5xl tracking-wide mt-4 font-semibold mb-12 text-center">
          UNLEASH YOUR GREATNESS
        </p>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <Button onClick={() => {
            const el = document.getElementById('programs');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}>EXPLORE COURSES</Button>
          
          {/* Dropdown Button */}
          <div 
            className="relative"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button 
              className="bg-custom-pink hover:bg-gold text-white font-bold py-4 px-8 rounded-full flex items-center transition duration-300"
            >
              PRICING & SCHOLARSHIPS
              <ChevronDown className="ml-2 h-5 w-5" />
            </button>
            
            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute top-full left-0 w-48 bg-white rounded-lg shadow-lg z-50 border-t-2 border-custom-pink">
                <Link 
                  to="/fees" 
                  className="block px-4 py-3 text-gray-800 hover:bg-gray-100 transition-colors duration-200"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Pricing
                </Link>
                <a 
                  href="https://giccs.or.tz/donation/application" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block px-4 py-3 text-gray-800 hover:bg-gray-100 transition-colors duration-200"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Scholarship
                </a>
              </div>
            )}
          </div>
          
          <Button onClick={() => {
            const el = document.getElementById('about');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            else window.location.assign('/about');
          }}>WHY JRIIT</Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
        <ChevronDown className="w-10 h-10 text-white animate-bounce rotate-90" />
      </div>

    </div>
  );
};

const Button = ({ children, onClick }) => (
  <button onClick={onClick} className="bg-custom-pink hover:bg-gold text-white font-bold py-4 px-8 rounded-full flex items-center transition duration-300">
    {children}
    <ChevronRight className="ml-2 h-5 w-5" />
  </button>
);

export default HeroSection;

